// redux/actions/employeeActions.js
import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const FETCH_EMPLOYEES_REQUEST = "FETCH_EMPLOYEES_REQUEST";
export const FETCH_EMPLOYEES_SUCCESS = "FETCH_EMPLOYEES_SUCCESS";
export const FETCH_EMPLOYEES_FAILURE = "FETCH_EMPLOYEES_FAILURE";

export const UPDATE_EMPLOYEE_REQUEST = "UPDATE_EMPLOYEE_REQUEST";
export const UPDATE_EMPLOYEE_SUCCESS = "UPDATE_EMPLOYEE_SUCCESS";
export const UPDATE_EMPLOYEE_FAILURE = "UPDATE_EMPLOYEE_FAILURE";

export const UPDATE_EMPLOYEE_STATUS_REQUEST = "UPDATE_EMPLOYEE_STATUS_REQUEST";
export const UPDATE_EMPLOYEE_STATUS_SUCCESS = "UPDATE_EMPLOYEE_STATUS_SUCCESS";
export const UPDATE_EMPLOYEE_STATUS_FAILURE = "UPDATE_EMPLOYEE_STATUS_FAILURE";

export const fetchEmployees = (params = {}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_EMPLOYEES_REQUEST });
    const token = localStorage.getItem("token");

    try {
      const response = await axios.get(`${BASE_URL}/v1/api/getAllEmployee`, {
        headers: { authorization: token },
        params: params,
      });
      dispatch({
        type: FETCH_EMPLOYEES_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_EMPLOYEES_FAILURE,
        payload: error.response?.data?.message || error.message,
      });
    }
  };
};

export const updateEmployee = (employeeData) => {
  return async (dispatch) => {
    const token = localStorage.getItem("token");

    dispatch({ type: UPDATE_EMPLOYEE_REQUEST });

    try {
      const res = await axios.post(
        `${BASE_URL}/v1/api/updateEmployee`,
        employeeData,
        {
          headers: {
            authorization: token,
            "Content-Type": "application/json",
          },
        },
      );

      dispatch({ type: UPDATE_EMPLOYEE_SUCCESS });
      toast.success("Employee updated successfully");
      return res.data;
    } catch (err) {
      dispatch({
        type: UPDATE_EMPLOYEE_FAILURE,
        payload: err.response?.data?.message || "Failed to update employee",
      });
      toast.error(err.response?.data?.message || "Failed to update employee");
      throw err;
    }
  };
};

export const updateEmployeeStatus = (user_id, status) => async (dispatch) => {
  dispatch({ type: UPDATE_EMPLOYEE_STATUS_REQUEST });
  try {
    const token = localStorage.getItem("token"); // or wherever you store auth
    await axios.post(
      `${BASE_URL}/v1/api/update-user-status`,
      { user_id, status },
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      },
    );
    dispatch({
      type: UPDATE_EMPLOYEE_STATUS_SUCCESS,
      payload: { user_id, status },
    });
  } catch (error) {
    dispatch({ type: UPDATE_EMPLOYEE_STATUS_FAILURE, payload: error.message });
  }
};
